<template>
  <v-form ref="form" lazy-validation >
  <v-card class="p-3">
    <v-card-title>Filter Tagged Photos</v-card-title>
    <v-card-text>
      <v-row align="end">
        <v-col cols="4">
         <v-checkbox
            v-model="onlyNeedsReview"
            :label="'Tagger marked as questionable'"
         ></v-checkbox>
        </v-col>

        <v-col cols="4">
         <v-checkbox
            v-model="showQCed"
            :label="'Show photos already QCed'"
         ></v-checkbox>
        </v-col>
      </v-row>
      <v-row align="end">
        <v-col cols="4">
          <date-picker v-model="fromDateVal" :initial-value="defaultFromDt" label="Tagged Date From"/>
        </v-col>
        <v-col cols="4">
          <date-picker v-model="thruDateVal" :initial-value="defaultToDt" label="Tagged Date Thru"/>
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="4">
          <v-autocomplete v-model="selectedTaggers"
                          :items="users"
                          :filter="taggerFilter"
                          chips
                          class="mt-4"
                          label="Taggers"
                          multiple
                          small-chips
          >
            <template v-slot:selection="data">
              <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeTaggerFromSelected( data.item)"
              >
                <div style="overflow: hidden">{{ data.item.email }}</div>
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="`${data.item.email}`"></v-list-item-title>
              </v-list-item-content>
            </template>

          </v-autocomplete>
        </v-col>

      </v-row>

      <v-row>
        <v-col cols="4">
          <v-autocomplete :items="allCats"
                          class="mt-4" item-text="name" item-value="id"
                          label="Tag Category" @input="filterTagByCategory"/>
        </v-col>

        <v-col cols="8">
          <v-autocomplete v-model="selectedTags"
                          :filter="tagFilter"
                          :items="filteredTags"
                          :search-input.sync="tagSearchInput"
                          chips
                          class="mt-4"
                          label="Tags"
                          multiple
                          small-chips
                          @change="tagSearchInput=''"
          >
            <template v-slot:selection="data">
              <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeTagFromSelected(data.item)"
              >
                {{ data.item.name }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                <v-list-item-subtitle v-if="data.item.category"
                                      v-html="data.item.category.name"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-autocomplete v-model="selectedProjects"
                          :filter="projectFilter"
                          :items="getProjects"
                          chips
                          class="mt-4"
                          label="Projects"
                          multiple
                          small-chips
          >
            <template v-slot:selection="data">
              <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeProjectFromSelected( data.item)"
              >
                <div style="overflow: hidden">{{ data.item.id }} - {{ data.item.name }}</div>
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="`${data.item.id} - ${data.item.name}`"></v-list-item-title>
              </v-list-item-content>
            </template>

          </v-autocomplete>
        </v-col>

        <v-col cols="6">
          <v-autocomplete v-model="selectedJobs"
                          :items="getJobs"
                          :filter="jobFilter"
                          chips
                          class="mt-4"
                          label="Jobs"
                          multiple
                          small-chips
          >
            <template v-slot:selection="data">
              <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeJobFromSelected( data.item)"
              >
                <div style="overflow: hidden">{{ data.item.id }} - {{ data.item.name }}</div>
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title v-html="`${data.item.id} - ${data.item.name}`"></v-list-item-title>
              </v-list-item-content>
            </template>

          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-text-field
              v-model="respIdSearchFreeForm"
              label="Mass Search Response IDs"
          ></v-text-field>
        </v-col>

        <v-col cols='4'>

            <v-select v-model='selectedRetailer'
              label='Retailer'
              :items='retailerChoices'
              :loading='$store.state.loading_list.includes("get_retailer_list")'
              clearable />

        </v-col>

        <v-col cols='4'>

            <v-select v-model='selectedDepartment'
              label='Department'
              :items='departmentChoices'
              :loading='$store.state.loading_list.includes("get_department_list")'
              clearable />

        </v-col>

        <v-col cols='4'>

            <v-autocomplete v-model='selectedCountry'
              :items='countries'
              :value='countries[0].value'
              item-text='label'
              item-value='value'
              label='Country'
              clearable />

        </v-col>
      </v-row>

    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" text @click="cancelClicked()">
        Cancel
      </v-btn>
      <v-btn color="success" text @click="okClicked()">
        Ok
      </v-btn>
    </v-card-actions>

  </v-card>
    </v-form>
</template>

<script>
import DatePicker from './DatePicker.vue'
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'QCPhotoFilterModal',
  components: {
    DatePicker
  },
  props: {
    photoFilters: {
      type: Object
    },
    retailerChoices: {
      type: Array,
      default: () => []
    },
    departmentChoices: {
        type: Array,
        default: () => []
    },
  },
  data() {
    return {
      selectedTags: [],
      selectedProjects: [],
      selectedJobs: [],
      selectedTaggers: [],
      tagSearchInput: null,
      responseIdSearchInput: null,
      fromDateVal: null,
      thruDateVal: null,
      filteredTags:[],
      respIdSearchFreeForm: null,
      onlyNeedsReview: false,
      showQCed: false,
      selectedCountry: null,
      countries: [
          {
              value: 'US',
              label: 'United States'
          },
          {
              value: 'CA',
              label: 'Canada'
          }
      ],
      selectedRetailer: null,
      selectedDepartment: null
    }
  },
  mounted() {
    this.filteredTags = this.tags
    this.selectedTags = this.photoFilters.tags
    this.selectedProjects = this.photoFilters.projects
    this.selectedJobs = this.photoFilters.jobs
    this.selectedTaggers = this.photoFilters.taggers
    this.onlyNeedsReview = this.photoFilters.onlyNeedsReview
    this.showQCed = this.photoFilters.showQCed

    if (this.photoFilters.fromDt != null) {
      this.fromDateVal = this.photoFilters.fromDt
    }

    if (this.photoFilters.thruDt != null) {
      this.thruDateVal = this.photoFilters.thruDt
    }

    if(this.photoFilters.respIdSearchFreeForm != null){
      this.respIdSearchFreeForm = this.photoFilters.respIdSearchFreeForm.toString()
    }

    this.selectedCountry = this.photoFilters.country
    this.selectedRetailer = this.photoFilters.retailer
    this.selectedDepartment = this.photoFilters.department

    this.$emit('modal-mounted', true)
  },
  computed: {
    ...mapState({
      tags: state => state.tags.tags,
      categories: state => state.categories.categories,
      users: state => state.users.users
    }),
    ...mapGetters(['getProjects', 'getJobs', 'getResponseIds']),
    allCats() {
      let cats = this.categories
      cats = cats.map(cat => ({id: cat.id, name: cat.name}))
      cats.push({id: 0, name: 'All'})
      return cats
    },
    defaultFromDt() {
      return this.fromDateVal;
    },
    defaultToDt() {
      return this.thruDateVal;
    }
  },
  methods: {
    removeTaggerFromSelected(tagger){
      let index = this.selectedTaggers.indexOf(tagger)
      if (index >=0) this.selectedTaggers.splice(index, 1)
    },
    taggerFilter(item, queryText, itemText){
      const cleanName = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()
      return cleanName.indexOf(searchText) > -1
    },
    removeTagFromSelected(tag) {
      let index = this.selectedTags.indexOf(tag)
      if (index >= 0) this.selectedTags.splice(index, 1)
    },
    tagFilter(item, queryText, itemText) {
      const cleanName = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return cleanName.indexOf(searchText) > -1
    },
    removeProjectFromSelected(prj) {
      let index = this.selectedProjects.indexOf(prj)
      if (index >= 0) this.selectedProjects.splice(index, 1)
    },
    projectFilter(item, queryText, itemText) {
      const cleanName = item.name.toLowerCase()

      const searchText = queryText.toLowerCase()
      return cleanName.indexOf(searchText) > -1 ||
          item.id.toString().indexOf(searchText) > -1
    },
    // removeResponseIdFromSelected(rid) {
    //   let index = this.selectedResponseIds.indexOf(rid)
    //   if (index >= 0) this.selectedResponseIds.splice(index, 1)
    // },
    // responseIdFilter(item, queryText, itemText) {
    //   const cleanName = item.id.toString().toLowerCase()
    //   const searchText = queryText.toString().toLowerCase()
    //   return cleanName.indexOf(searchText) > -1 ||
    //       item.id.toString().indexOf(searchText) > -1
    // },
    removeJobFromSelected(job) {
      let index = this.selectedJobs.indexOf(job)
      if (index >= 0) this.selectedJobs.splice(index, 1)
    },
    jobFilter(item, queryText, itemText) {
      const cleanName = item.name.toLowerCase()

      const searchText = queryText.toLowerCase()
      return cleanName.indexOf(searchText) > -1 ||
          item.id.toString().indexOf(searchText) > -1
    },
    filterTagByCategory(e) {
      var filteredTags = null;
      if (e !== 0) {
        filteredTags = this.tags.filter(tag => tag.category.id === parseInt(e))

      } else {
        filteredTags = this.tags
      }

      this.filteredTags = filteredTags

    },
    cancelClicked() {
      this.$emit('dialog-clicked')
    },
    okClicked() {
      let selectedFilters = {
        fromDt: this.fromDateVal,
        thruDt: this.thruDateVal,
        onlyUntagged: this.onlyUntagged,
        onlyNeedsReview: this.onlyNeedsReview,
        showQCed: this.showQCed,
        country: this.selectedCountry,
        retailer: this.selectedRetailer,
        department: this.selectedDepartment
      }

      // Tags
      Object.assign(selectedFilters, {tags: this.selectedTags})
      // Projects
      Object.assign(selectedFilters, {projects: this.selectedProjects})
      // Jobs
      Object.assign(selectedFilters, {jobs: this.selectedJobs})
      // Taggers
      Object.assign(selectedFilters, {taggers: this.selectedTaggers})
      //Mass Search Response IDs
      Object.assign(selectedFilters, {respIdSearchFreeForm: this.respIdSearchFreeForm})


      this.$emit('apply-filters', selectedFilters)
      this.$emit('dialog-clicked')

    }

  }
}
</script>

<style>
</style>
